var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSurveymonkey = function SvgSurveymonkey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 43,
    fill: "none",
    viewBox: "0 0 40 43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2315_173498)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00BF6F",
    stroke: "#fff",
    strokeWidth: 1.415,
    d: "m21.017 3.076 12.162 7.039a2.78 2.78 0 0 1 1.383 2.403v14.078c0 .992-.528 1.908-1.383 2.404l-12.162 7.038a2.76 2.76 0 0 1-2.765 0L6.091 29a2.78 2.78 0 0 1-1.384-2.404V12.518c0-.992.528-1.908 1.384-2.403l12.161-7.04a2.76 2.76 0 0 1 2.765 0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2315_173498)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.152 19.914q-.288 0-.568.071a7.4 7.4 0 0 0-2.105-3.589 7.3 7.3 0 0 0-4.062-1.924c.021-.698.054-1.507 1.072-2.232l-.158-.41s-1.982.622-2.21 2.338c-.099-.467-1.024-1.051-1.481-1.161l-.228.371a1.6 1.6 0 0 1 .744 1.15 7.3 7.3 0 0 0-3.693 1.869 7.4 7.4 0 0 0-2.106 3.59 2.35 2.35 0 0 0-2.096.49c-.287.242-.513.55-.66.897a2.42 2.42 0 0 0 .143 2.169c.19.325.455.6.77.801a2.36 2.36 0 0 0 2.143.205c.203.512.461.999.772 1.452l1.97-1.343-.016-.023c-.521-.677-.842-1.674-.894-2.666-.058-1.094.205-2.181.897-2.82 1.42-1.227 2.978-.67 3.945.508h.262c.973-1.175 2.526-1.735 3.946-.509.692.638.957 1.727.897 2.821-.054.992-.373 1.989-.893 2.666l-.018.023L25.497 26c.31-.453.569-.94.771-1.452a2.35 2.35 0 0 0 2.011-.134c.305-.17.57-.406.774-.69a2.41 2.41 0 0 0 .381-2 2.4 2.4 0 0 0-.464-.932 2.38 2.38 0 0 0-1.818-.88m-15.404 3.108a.7.7 0 0 1-.496-.208.71.71 0 0 1 0-1.001.7.7 0 0 1 .889-.085q.008.56.074 1.117a.7.7 0 0 1-.467.177m15.452 0a.7.7 0 0 1-.474-.182q.066-.556.074-1.116a.694.694 0 0 1 .995.22c.065.11.1.238.099.366a.71.71 0 0 1-.201.501.7.7 0 0 1-.494.21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2315_173498"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.153 10.026h20.612v20.612H9.153z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2315_173498",
    width: 38.765,
    height: 42.615,
    x: 0.252,
    y: 0.123,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.874
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.874
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2315_173498"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2315_173498",
    result: "shape"
  })))));
};
export default SvgSurveymonkey;